import { gql } from "@apollo/client";

const SEARCH_QUERY = gql`
  query GetCustomer($search: String) {
    products: products(where: { search: $search }) {
      nodes {
        name
        slug
        image {
          sourceUrl
          altText
        }
      }
    }

    tags: productTags(where: { search: $search }) {
      nodes {
        name
        slug
      }
    }

    categories: productCategories(where: { search: $search }) {
      nodes {
        name
        slug
      }
    }

    posts: posts(where: { search: $search }) {
      nodes {
        slug
        excerpt
        title
        categories {
          nodes {
            slug
          }
        }
      }
    }
  }
`;

export default SEARCH_QUERY;
